module.exports = __webpack_public_path__ + "img/tile_one.df207192.png";